<div class="select-container">
  <select (change)="onSelect($event)">
    <option value="">{{ emptyLabel }}</option>
    @for (option of options; track option) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>
  <div class="label">
    {{ selected == undefined ? emptyLabel : selected!.label }}
  </div>
  <div class="dropdown">
    <img ngSrc="./assets/dropdown.svg" alt="Select">
  </div>
</div>
